//social-feed

export default function initsocialfeed(){
    $(".socialfeed").each(function () {
        var that = $(this);
        let url = "";

        if (that.hasClass("pin")) {
            url = "https://www.chefsculinar.de/pinfeed.json";
        }
        else if (that.hasClass("ig")) {
            url = "https://www.chefsculinar.de/instafeed.json";
        }
        else {
            url = "https://www.chefsculinar.de/fbfeed.json";
        }
        $.ajax({
            url: url
        }).done(function (res) {
            if (that.hasClass("pin")) {
                extractPinData(res, that);
            }
            else if (that.hasClass("ig")) {
                extractInstagramData(res, that);
            }
            else {
                extractFBData(res, that);
            }
        });
    });

    function extractInstagramData(res, that) {
        var posts = res["data"];
        var seed = Math.random().toString().replace(".", "");
        for (var x = 0; x < posts.length; x++) {
            if (x > 11) {
                break;
            }
            var newFeedItem = $("<div class='itemwrapper'><div class='feeditem'></div></div>");
            var item = newFeedItem.find(".feeditem");
            item.css("background-image", "url('" + posts[x]["media_url"] + "')");
            item.data("imgurl", posts[x]["media_url"]);
            item.data("title", "");

            item.data("message", posts[x]["caption"]);
            item.data("likesnum", posts[x]["like_count"] !== undefined ? posts[x]["like_count"] : 0);
            item.data("commentsnum", posts[x]["comments_count"] !== undefined ? posts[x]["comments_count"] : 0);
            item.data("originalurl", posts[x]["permalink"]);
            item.attr("data-itemid", x + seed);
            var dateRegex = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2})\.[0-9Z]{4}$/g;
            //var tempDate = new Date(parseInt(res[x]["node"]["taken_at_timestamp"])*1000);
            //tempDate.setTime(tempDate.getTime() + (2*60*60*1000));
            //var dateString = tempDate.toISOString();
            var dateString = posts[x]["timestamp"];
            var matches = dateRegex.exec(dateString);
            if (matches !== null) {
                var weekDays = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
                var weekDay = weekDays[new Date(matches[1] + "-" + matches[2] + "-" + matches[3]).getDay()];
                var date = weekDay + ", " + matches[3] + "." + matches[2] + "." + matches[1] + " um " + matches[4] + ":" + matches[5] + " Uhr";
                item.data("date", date);

            }
            that.append(newFeedItem);
        }
        var width = $(".socialfeed .itemwrapper").width();
        $(".socialfeed .itemwrapper").height(width);
    }

    function extractFBData(res, that) {
        var seed = Math.random().toString().replace(".", "");
        for (var x = 0; x < res["data"].length; x++) {
            if (x > 11) {
                break;
            }
            var newFeedItem = $("<div class='itemwrapper'><div class='feeditem'></div></div>");
            var item = newFeedItem.find(".feeditem");
            item.css("background-image", "url('" + res["data"][x]["full_picture"] + "')");
            item.data("imgurl", res["data"][x]["full_picture"]);
            item.data("title", res["data"][x]["name"]);

            item.data("message", res["data"][x]["message"]);
            try {
                item.data("likesnum", res["data"][x]["shares"]["count"] !== undefined ? res["data"][x]["shares"]["count"] : 0);

            }
            catch (e) {

            }
            item.data("commentsnum", res["data"][x]["comments"] !== undefined ? res["data"][x]["comments"]["data"].length : 0);
            item.data("originalurl", res["data"][x]["permalink_url"]);
            item.attr("data-itemid", x + seed);
            var dateRegex = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2})\+[0-9]{4}$/g;
            var dateString = res["data"][x]["created_time"];
            var matches = dateRegex.exec(dateString);
            if (matches !== null) {
                var weekDays = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
                var weekDay = weekDays[new Date(matches[1] + "-" + matches[2] + "-" + matches[3]).getDay()];
                var date = weekDay + ", " + matches[3] + "." + matches[2] + "." + matches[1] + " um " + matches[4] + ":" + matches[5] + " Uhr";
                item.data("date", date);

            }
            that.append(newFeedItem);
        }
        var width = $(".socialfeed .itemwrapper").width();
        $(".socialfeed .itemwrapper").height(width);
    }

    function extractPinData(res, that) {
        var seed = Math.random().toString().replace(".", "");
        for (var x = 0; x < res.length; x++) {
            if (x > 11) {
                break;
            }
            var newFeedItem = $("<div class='itemwrapper'><div class='feeditem'></div></div>");
            var item = newFeedItem.find(".feeditem");
            item.css("background-image", "url('" + res[x]["images"]["474x"]["url"] + "')");
            item.data("imgurl", res[x]["images"]["474x"]["url"]);
            item.data("title", res[x]["description"]);
            item.data("date", res[x]["created_at"]);
            item.data("message", res[x]["description"]);
            //item.data("likesnum",res[x]["likes"] !== undefined ? res[x]["likes"].length : 0);
            //item.data("commentsnum",res[x]["comments"] !== undefined ? res[x]["comments"].length : 0);
            item.data("originalurl", "https://www.pinterest.de/pin/" + res[x]["id"] + "/");
            item.attr("data-itemid", x + seed);

            that.append(newFeedItem);
        }
        var width = $(".socialfeed .itemwrapper").width();
        $(".socialfeed .itemwrapper").height(width);
    }

    $(window).on("resize", function () {
        $(".socialfeed .itemwrapper").height($(".socialfeed .itemwrapper").width());
    });

    var socialfeedLightboxTemplate = "<div class=\"socialfeed-lightbox\"><div class=\"socialfeed-lightbox-container\"><div class=\"closelink\"><a>schließen</a></div><div class='imgwrapper'><button class=\"leftarrow-round\"></button><button class=\"rightarrow-round\"></button><img src=\"\" alt=\"\"></div><div class=\"text\"><div class=\"title\"></div><div class=\"date\"></div><div class=\"message\"></div><span class=\"likescomments\">(<span class=\"likesnum\"></span> Likes, <span class=\"commentsnum\"></span> Kommentar<span class=\"multiple\">e</span>)</span> <a href=\"\" class=\"original-link\">Original ansehen</a></div></div></div>";

    function loadFeeditemToSlider(slider, feeditem) {
        slider.find("img").attr("src", feeditem.data("imgurl"));
        slider.find(".title").text(feeditem.data("title"));
        slider.find(".message").text(feeditem.data("message"));
        slider.find(".likesnum").text(feeditem.data("likesnum"));
        slider.find(".commentsnum").text(feeditem.data("commentsnum"));
        slider.find(".original-link").attr("href", feeditem.data("originalurl"));
        slider.attr("data-itemid", feeditem.attr("data-itemid"));
        slider.find(".date").text(feeditem.data("date"));
    }

    $("body").on("click", ".socialfeed .feeditem", function (e) {
        e.stopPropagation();
        var socialfeedLightbox = $(socialfeedLightboxTemplate);

        try {
            loadFeeditemToSlider(socialfeedLightbox, $(this));
        }
        finally {
            $("body").addClass("socialfeed-lightbox-active");
            $("body").append(socialfeedLightbox);
            if ($(this).parents(".socialfeed").hasClass("pin")) {
                socialfeedLightbox.addClass("pin");
            }
            if ($(this).parents(".socialfeed").hasClass("ig")) {
                socialfeedLightbox.addClass("ig");
            }
        }
    });

    $("body").on("click", function () {
        $(this).removeClass("socialfeed-lightbox-active");
        $("body").find(".socialfeed-lightbox").remove();
    });
    $("body").on("click", ".socialfeed-lightbox-container", function (e) {
        e.stopPropagation();
    });

    function socialfeedSlideLeft(feed) {
        var oldItem = $(".socialfeed .feeditem[data-itemid=" + feed.attr("data-itemid") + "]").parent();

        var newItem = oldItem.prev().length === 0 ? oldItem.nextAll().last().find(".feeditem") : oldItem.prev().find(".feeditem");

        loadFeeditemToSlider(feed, newItem);
    }

    function socialfeedSlideRight(feed) {
        var oldItem = $(".socialfeed .feeditem[data-itemid=" + feed.attr("data-itemid") + "]").parent();

        var newItem = oldItem.next().length === 0 ? oldItem.prevAll().last().find(".feeditem") : oldItem.next().find(".feeditem");

        loadFeeditemToSlider(feed, newItem);
    }

    $("body").on("click", ".socialfeed-lightbox .leftarrow-round", function () {
        socialfeedSlideLeft($(this).parents(".socialfeed-lightbox"));
    });
    $("body").on("click", ".socialfeed-lightbox .rightarrow-round", function () {
        socialfeedSlideRight($(this).parents(".socialfeed-lightbox"));
    });

    $("body").on("click", ".socialfeed-lightbox .closelink a", function () {
        $(".socialfeed-lightbox").remove();
    });
}
